import React, { Component } from 'react';
import { 
  Navbar,
  Nav,
  NavDropdown,
  NavItem,
  MenuItem,
} from 'react-bootstrap/lib';
import {
  firebaseAuth,
  firebaseDb,
} from '../lib/firebase/firebase';

class TopBar extends Component {

  constructor(props){
    super(props);

    this.state = {

    }
  }

  onLogout(){
    firebaseAuth.signOut();
  }

  getUserItems(){
    var items = [];
    if(this.props.user){
      items = (
        <NavDropdown title={this.props.user.email?this.props.user.email:"..."} id="basic-nav-dropdown">
          <MenuItem>Profile</MenuItem>
          <MenuItem divider />
          <MenuItem onClick={this.onLogout.bind(this)}>Logout</MenuItem>
        </NavDropdown>
      );
    }
    return items;
  }

  render(){
    var user_items = this.getUserItems();
    return (
      <Navbar
        collapseOnSelect
        inverse
        fixedTop >
        <Navbar.Header>
          <Navbar.Brand>
            <a href="/">PlayAdmin</a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            {user_items}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  };
}

export default TopBar;


// WEBPACK FOOTER //
// ./src/components/TopBar.js